/**
 *
 * Styles for OfferAddOns
 *
 */

import styled, { css } from "styled-components";
import { Headline } from "root/libs/ui-components/src";
import { breakpoints } from "root/libs/ui-styleguide/src";
import { DhlAccordion, DhlPanel, DhlText } from "@dhl-official/react-library";

const lightBorder = `1px solid var(--dui-color-gray-200)`;

export const AddOnsWrapper = styled.div`
  border-top: ${(props) => {
    if (
      props.variationType === "WCCMultiBUOfferCard" ||
      props.variationType === "WCCOfferCard"
    ) {
      return lightBorder;
    }
    return null;
  }};
  margin-bottom: var(--gaq-size-space-30px);

  padding-top: ${(props) => {
    if (
      props.variationType === "WCCMultiBUOfferCard" ||
      props.variationType === "WCCOfferCard"
    ) {
      return "var(--gaq-size-space-15px) 0 0 0;";
    }
    return null;
  }};

  @media screen and (min-width: ${breakpoints.tablet}) {
    margin-bottom: ${(props) => {
      if (
        props.variationType === "WCCMultiBUOfferCard" ||
        props.variationType === "WCCOfferCard"
      ) {
        return "var(--gaq-size-space-30px);";
      }
      return "var(--dui-size-space-5x)";
    }};
    padding: ${(props) => {
      if (props.variationType === "WCCMultiBUOfferCard") {
        return "var(--gaq-size-space-15px) var(--dui-size-space-5x) 0 var(--dui-size-space-5x);";
      }
      if (props.variationType === "WCCOfferCard") {
        return "var(--gaq-size-space-15px) 0 0 0;";
      }
      return null;
    }};
  }
`;

export const StyledHeadline = styled(Headline)`
  margin-bottom: var(--dui-size-space-10x);
  font-stretch: normal !important;
`;

export const StyledAccordion = styled(DhlAccordion)`
  padding: 0;
`;

export const StyledPanel = styled(DhlPanel)`
  &
    > div:not(.button-only-trigger):is(:hover, &
      > div:not(.button-only-trigger):focus-within):not(.disabled) {
    box-shadow: var(--dui-size-space-0) var(--dui-size-space-1)
        var(--dui-size-space-0) var(--dui-size-space-0)
        var(--dui-color-gray-500),
      inset var(--dui-size-space-0) var(--dui-size-space-1)
        var(--dui-size-space-0) var(--dui-size-space-0)
        var(--dui-color-gray-500) !important;
  }

  & > div > dhl-headline > p[style] {
    --stretch: normal !important;
    --weight: var(--dui-font-weight-normal) !important;
    font-size: 1.5rem !important;
  }

  & > div > dhl-headline > p > dhl-button > button {
    align-items: center !important;
    padding-top: var(--dui-size-space-4x) !important;
    padding-bottom: var(--dui-size-space-4x) !important;

    @media screen and (min-width: ${breakpoints.tablet}) {
      padding-top: var(--dui-size-space-5x) !important;
      padding-bottom: var(--dui-size-space-5x) !important;
    }

    &[aria-expanded="true"] {
      margin-top: var(--gaq-size-space--1px) !important;
      border-bottom: var(--dui-size-width-border-sm) solid
        var(--dui-color-gray-700);
      border-top: var(--dui-size-width-border-sm) solid
        var(--dui-color-gray-700);

      &:focus {
        outline-offset: -2px;
        outline: 2px solid var(--dui-color-gray-700);
      }
    }
  }
`;

export const StyledContent = styled(DhlText)`
  --weight: 400;
  --style: normal;
  --stretch: normal;
  display: block;
  padding-top: var(--dui-size-space-10x);
  font-size: 1.5rem !important;

  & > *:is(p, span) {
    display: block;
    font-size: inherit !important;
    margin-bottom: 1.4rem !important;
  }
`;

export const AddOnsContent = styled.div`
  .accordion {
    margin-bottom: 0;
  }

  @media screen and (min-width: ${breakpoints.tablet}) {
    margin-right: 0;
    margin-left: ${(props) =>
      props.variationType === "WCCOfferCard"
        ? false
        : `calc(var(--dui-size-space-5x) + var(--dui-size-space-1))`};
  }
`;

export const OfferAddOnsContentExtraStyles = css`
  white-space: pre-line;
`;
